var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0080fd7451dbcff4f4a238f49085a20afc52bb01"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["itf@codeurs-bvba"]={id:"0080fd7451dbcff4f4a238f49085a20afc52bb01"};
      